import { render, staticRenderFns } from "./FoodTodoBookingCard.vue?vue&type=template&id=24a4b4e3&scoped=true&lang=pug&"
import script from "./FoodTodoBookingCard.vue?vue&type=script&lang=ts&"
export * from "./FoodTodoBookingCard.vue?vue&type=script&lang=ts&"
import style0 from "./FoodTodoBookingCard.vue?vue&type=style&index=0&id=24a4b4e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a4b4e3",
  null
  
)

export default component.exports